import { render, staticRenderFns } from "./OrderExamples.vue?vue&type=template&id=76fc0bbf&scoped=true"
import script from "./OrderExamples.vue?vue&type=script&lang=js"
export * from "./OrderExamples.vue?vue&type=script&lang=js"
import style0 from "./OrderExamples.vue?vue&type=style&index=0&id=76fc0bbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc0bbf",
  null
  
)

export default component.exports